/**
 * @generated SignedSource<<9881f126a860b7650e97254802b24377>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OwnerPersistentWorkerPools_info$data = {
  readonly persistentWorkerPools: ReadonlyArray<{
    readonly enabledForPublic: boolean;
    readonly id: string;
    readonly name: string;
  }>;
  readonly platform: string;
  readonly uid: string;
  readonly " $fragmentType": "OwnerPersistentWorkerPools_info";
};
export type OwnerPersistentWorkerPools_info$key = {
  readonly " $data"?: OwnerPersistentWorkerPools_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"OwnerPersistentWorkerPools_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OwnerPersistentWorkerPools_info",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platform",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PersistentWorkerPool",
      "kind": "LinkedField",
      "name": "persistentWorkerPools",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabledForPublic",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OwnerInfo",
  "abstractKey": null
};

(node as any).hash = "6075929dd569e4f33cccca992cb962ef";

export default node;
